import { connect } from 'react-redux';

import ChangeStatusModal from '../../components/Rca/ChangeStatusModal';
import { getModalParams, isModalOpen } from '../../store/Modal/selectors';
import { AppState } from '../../store/types';
import { closeModal } from '../../store/Modal/actionCreators';
import { deny } from '../../store/Rca/actionCreators';

export const name = 'DENY_RCA_MODAL';

const mapStateToProps = (state: AppState) => ({
    isOpened: isModalOpen(state, {name}),
    params: getModalParams(state),
    title: 'Deny RCA',
    body: 'Are you sure you want deny this RCA?',
});

const mapDispatchToProps = {
    toggle: closeModal,
    apply: deny
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeStatusModal);
